import * as React from 'react';

const QuestionCircle16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8 1.5A6.5 6.5 0 1 1 1.5 8 6.51 6.51 0 0 1 8 1.5M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8.733 8.87c-.036.413-.319.75-.733.75s-.764-.336-.75-.75c.014-.42.075-.83.3-1.211a2.17 2.17 0 0 1 .88-.829c.422-.187.67-.68.57-1.13a1.01 1.01 0 0 0-.72-.7 1.01 1.01 0 0 0-1.027.298c-.276.313-.6.702-1.017.702-.406 0-.746-.336-.628-.726a2.5 2.5 0 0 1 .238-.544c.699-1.184 2.306-1.585 3.482-.848a2.54 2.54 0 0 1 1.168 2.254 2.5 2.5 0 0 1-.415 1.249c-.322.485-.984.647-1.248 1.121a.9.9 0 0 0-.1.365ZM8 10.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
  }
));
QuestionCircle16.Size = 16;
QuestionCircle16.Title = "QuestionCircle";

export { QuestionCircle16 as default };
